import styles from './new-cars-menu.module.css'
import { useContext } from 'react'
import { SharedUiHeaderV2Context } from '../../context/context-shared-ui-header-v2'
import { parentLinks } from '../../../data/parent-menu'
import {
  newCarBrands,
  newCarsFAQs,
  newCarsSnippets,
} from '../../../data/new-cars'
import { ListWrapper } from '../list-wrapper/list-wrapper'
import { ListItem } from '../list-item/list-item'
import { ListSnippetMapper } from '../list-snippet-mapper/list-snippet-mapper'
import { BrandsList } from '../brands-list/brands-list'
import { Secondary } from '@cinch-labs/design-system'

export interface PartExchangeMenuProps {
  isMobile?: boolean
  handleFaqClick?: (value: string | null) => void
  setShouldShowMobileMenu?: () => void
}

export const NewCarsMenu = ({
  isMobile,
  handleFaqClick,
  setShouldShowMobileMenu,
}: PartExchangeMenuProps) => {
  const { logicStore } = useContext(SharedUiHeaderV2Context)

  const { handleTrackEvent } = logicStore

  return (
    <>
      <nav className={styles.firstColumn}>
        <ListWrapper heading={'New cars'}>
          <BrandsList brandsList={newCarBrands} />
        </ListWrapper>
        <Secondary href="/new-cars" element="a" isFullWidth>
          Shop all new cars
        </Secondary>
      </nav>
      {isMobile && <hr className={styles.horizontalLine} />}
      <nav className={styles.secondColumn}>
        <ListSnippetMapper
          snippets={newCarsSnippets}
          label={parentLinks.NEWCARS}
          isMobile={isMobile}
        />
      </nav>
      <nav className={styles.container}>
        <ListWrapper
          heading={'FAQs'}
          urlText={'Go to help and support'}
          href={'https://help.cinch.co.uk/hc/en-gb'}
          handleTrackEvent={() =>
            handleTrackEvent({
              name: 'click',
              category: 'mega menu',
              label: parentLinks.NEWCARS,
              action: 'FAQ',
              value: 'Go to support',
            })
          }
        >
          <>
            {newCarsFAQs.map((faq) => (
              <li key={faq.label} className={styles.faqList}>
                <ListItem
                  label={faq.label}
                  href={faq.href}
                  ariaLabel={faq.ariaLabel}
                  handleClickEvent={() => {
                    handleTrackEvent({
                      name: 'click',
                      category: 'mega menu',
                      label: parentLinks.NEWCARS,
                      action: 'FAQ',
                      value: faq.label,
                    })
                    // handleFaqClick solve the scroll issue on desktop
                    handleFaqClick && handleFaqClick(null)
                    if (setShouldShowMobileMenu) {
                      setShouldShowMobileMenu()
                    }
                  }}
                />
              </li>
            ))}
          </>
        </ListWrapper>
      </nav>
    </>
  )
}
